import React from 'react'

import { Context } from './contexts'

/*
  This hook and context provider allow a tree of components to coordinate the data
  and visibility of a floating menu. This is used in rundowns by mounting a context
  menu on the toolbar but positioning it dynamically based on where the mouse event
  was triggered
*/

export const FloatingMenuProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [coords, setCoords] = React.useState<XYCoords | null>(null)
  return (
    <Context.Provider value={{ coords, setCoords }}>
      {children}
    </Context.Provider>
  )
}
